/*
 * Copyright (c) 2024-2026. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
 */

import { z } from 'zod'
import { withValidate } from 'lib/zod-validate'

export const BookingSellerVoucherSchema = withValidate(z.object({
    priceDiscount: z.number().int().min(1).max(1000),
}))

export type BookingSellerVoucherInputs = z.infer<
    typeof BookingSellerVoucherSchema
>
